module.exports = __webpack_public_path__ + "img/Avatar Selection Screen.d0dce3ac.jpg";